import * as z from "zod";

const pricingTestVariantPriceSchema_ = z.object({
  variantId: z.string(),
  price: z.number(),
});
export const pricingTestVariantPriceSchema: z.ZodType<PricingTestVariantPriceSchema> =
  pricingTestVariantPriceSchema_;
export interface PricingTestVariantPriceSchema extends z.infer<
  typeof pricingTestVariantPriceSchema_
> {}

const pricingTestTreatmentSchema_ = z.object({
  _id: z.string(),
  name: z.string(),
  weight: z.number(),
  variantPrices: z.array(pricingTestVariantPriceSchema),
});
export const pricingTestTreatmentSchema: z.ZodType<PricingTestTreatmentSchema> =
  pricingTestTreatmentSchema_;
export interface PricingTestTreatmentSchema extends z.infer<
  typeof pricingTestTreatmentSchema_
> {}

const pricingTestSchema_ = z.object({
  _id: z.string(),
  name: z.string(),
  active: z.boolean(),
  createdAt: z.string(),
  endDate: z.string().nullable().optional(),
  treatments: z.array(pricingTestTreatmentSchema),
});
export const pricingTestSchema: z.ZodType<PricingTestSchema> =
  pricingTestSchema_;
export interface PricingTestSchema extends z.infer<typeof pricingTestSchema_> {}

export const getPricingTests = {
  name: "getPricingTests" as const,
  input: z.object({}),
  output: z.object({ pricingTests: z.array(pricingTestSchema) }),
};
